import React from "react";

function Button({
  children,
  type = "button",
  bgColor = "primary",
  textColor = "white",
  className = "",
  icon = "",
  ...props
}) {
  return (
    <button
      className={`btn btn-${bgColor} text-${textColor} ${className}`}
      {...props}
    >
      <i className={`bi bi-${icon}`}></i> {children}
    </button>
  );
}

export default Button;
